import script from "./SurveyFeedbackView.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyFeedbackView.vue?vue&type=script&setup=true&lang=js"

import "./SurveyFeedbackView.vue?vue&type=style&index=0&id=52c16896&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52c16896"]])

export default __exports__